var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid mt-5"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6 order-xl-1"},[_c('div',[_c('user-edit-card',{attrs:{"user":_vm.user}})],1)]),_c('div',{staticClass:"col-xl-6 order-xl-2"},[_c('user-password-card',{attrs:{"user":_vm.user}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }